import { library } from '@fortawesome/fontawesome-svg-core';
import { faLightbulb as farLightBulb } from '@fortawesome/free-regular-svg-icons';
import { faLightbulb as fasLightBulb, faSignInAlt, faSignOutAlt, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { fromJS } from 'immutable';
import { Logger } from 'logger';
import 'react-datetime/css/react-datetime.css';
import { Provider } from 'react-redux';
import { initializeStore, subscribeListener } from 'redux/ably/sagas';
import { GlobalStyle } from './assets/theme';
import { ThemeProvider } from './assets/theme/ThemeContext';
import rdt from './DevTools';
import { Openfin } from './openfin/OpenfinAdapter';
import { OpenfinProvider } from './openfin/OpenfinContext';
import configureStore from './redux/store';
import Routes from './router';
import RouteWrapper from './RouteWrapper/RouteWrapper';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import worker_script from './components/SetInterval/SetIntervalWorker';

library.add(fasLightBulb, farLightBulb, faSignInAlt, faSignOutAlt, faSortUp, faSortDown);

const debugLog = Logger.create('App.tsx')

debugLog(rdt);

const initialState = fromJS({}) as any;
const store = configureStore(initialState);

(window as any).openfin = Openfin;

const App: React.FunctionComponent<{keycloak: any}> = ({keycloak}) => {
  subscribeListener('store:connected', 1, ({ data }) => {
    if (data === WebSocket.OPEN) {
      initializeStore(keycloak.getToken() || '');
    }
  });

  let intervalWorker = new Worker(worker_script);
  intervalWorker.onmessage = (e) => {
    /* eslint-disable no-console */
    console.log("check keycloak token: " + new Date());
    /* eslint-enable no-console */
  const minValiditySeconds = 60;
  if (keycloak.tokenExpired(minValiditySeconds)) {
    /* eslint-disable no-console */
    console.log("update keycloak token: " + new Date());
    /* eslint-enable no-console */
      keycloak.updateToken(minValiditySeconds);
    }
  }

  return (
    <OpenfinProvider value={Openfin}>
      <Provider store={store}>
        <ThemeProvider>
          <GlobalStyle />
          <DndProvider backend={HTML5Backend}>
            <RouteWrapper>
              <Routes keycloak={keycloak} />
            </RouteWrapper>
          </DndProvider>
        </ThemeProvider>
      </Provider>
    </OpenfinProvider>
)}

export default App;

